import axios from '@axios'

export const state = {
  states: [],
  cities: [],
  currentPage: 1,
  perPage: 15,
  totalPage: 1,
  totalRecord: 0,
}

export const getters = {
  allStates: (state) => state.states,
  allCities: (state) => state.cities,
  currentPage: (state) => state.currentPage,
  perPage: (state) => state.perPage,
  totalPage: (state) => state.totalPage,
  totalRecord: (state) => state.totalRecord,
}

export const mutations = {
  CLEAR_STATE_STATE: (state) => {
    state.states = []
    state.currentPage = 1
    state.perPage = 15
    state.totalPage = 1
    state.totalRecord = 0
  },
  CLEAR_CITY_STATE: (state) => {
    state.cities = []
    state.currentPage = 1
    state.perPage = 15
    state.totalPage = 1
    state.totalRecord = 0
  },
  GET_STATES: (state, resp) => {
    if (!resp) return null
    state.states = resp.states
    state.currentPage = resp.page
    state.perPage = resp.perPage
    state.totalPage = resp.totalPages
    state.totalRecord = resp.totalRecords
  },
  GET_CITIES: (state, resp) => {
    if (!resp) return null
    state.cities = resp.citys
    state.currentPage = resp.page
    state.perPage = resp.perPage
    state.totalPage = resp.totalPages
    state.totalRecord = resp.totalRecords
  },
  COLOR_COLOR: (state, car) => {
    // car.id = new Date().getTime()
    // state.cars.push(car)
  },
  UPDATE_COLOR: (state, car) => {
    // for (let i = 0; i < state.cars.length; i++) {
    //   if (state.cars[i].id === car.id) {
    //     car.id = new Date().getTime()
    //     for (let field in state.cars[i]) {
    //       state.cars[i][field] = car[field]
    //     }
    //     break
    //   }
    // }
  },
  REMOVE_COLOR: (state, deletedCar) => {
    // state.cars = state.cars.filter((car) => car.id !== deletedCar.id)
  },
}

export const actions = {
  async getStates({ commit }) {
    commit('CLEAR_STATE_STATE')
    await axios
      .get(`/api/states`)
      .then((resp) => {
        if (resp.status === 200) {
          commit('CLEAR_STATE_STATE')
          let data = Object.assign({}, resp.data)
          commit('GET_STATES', data)
        }
      })
      .catch(() => {
        commit('GET_STATES', null)
      })
  },
  async getCitiesByStateId({ commit }, stateId) {
    commit('CLEAR_CITY_STATE')
    await axios
      .get(`/api/cities`)
      .then((resp) => {
        if (resp.status === 200) {
          commit('CLEAR_CITY_STATE')
          let data = Object.assign({}, resp.data)
          commit('GET_CITIES', data)
        }
      })
      .catch(() => {
        commit('GET_CITIES', null)
      })
  },
}
